import { useState, useCallback } from 'react'
import { lumi } from '@/lib/lumi'

export interface ExpressCandidate {
  _id: string
  companyUserId: string
  companyName?: string
  fullName: string
  phone?: string
  email?: string
  source?: string
  notes?: string
  creator?: string
  createdAt: string
  updatedAt: string
}

export function useExpressCandidates() {
  const [candidates, setCandidates] = useState<ExpressCandidate[]>([])
  const [loading, setLoading] = useState(false)

  const fetchByCompany = useCallback(async (companyUserId: string) => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.express_candidates.list({
        filter: { companyUserId },
        sort: { createdAt: -1 },
      })
      setCandidates(list as ExpressCandidate[])
    } catch (e) {
      console.error('Error al cargar candidatos express (empresa):', e)
    } finally {
      setLoading(false)
    }
  }, [])

  const fetchAll = useCallback(async () => {
    setLoading(true)
    try {
      const { list } = await lumi.entities.express_candidates.list({
        sort: { createdAt: -1 },
      })
      setCandidates(list as ExpressCandidate[])
    } catch (e) {
      console.error('Error al cargar candidatos express:', e)
    } finally {
      setLoading(false)
    }
  }, [])

  const createCandidate = useCallback(async (data: Partial<ExpressCandidate>) => {
    const now = new Date().toISOString()
    return lumi.entities.express_candidates.create({
      ...data,
      source: data.source || 'express',
      createdAt: now,
      updatedAt: now,
    })
  }, [])

  const updateCandidate = useCallback(async (id: string, data: Partial<ExpressCandidate>) => {
    return lumi.entities.express_candidates.update(id, {
      ...data,
      updatedAt: new Date().toISOString(),
    })
  }, [])

  const deleteCandidate = useCallback(async (id: string) => {
    return lumi.entities.express_candidates.delete(id)
  }, [])

  return {
    candidates,
    loading,
    fetchByCompany,
    fetchAll,
    createCandidate,
    updateCandidate,
    deleteCandidate,
  }
}
